<app-breadcrumbs title="{{ id ? 'TEMPLATES.EDIT_TITLE' : 'TEMPLATES.CREATE_TITLE' }}" [first]="'MENU.DATA_MANAGEMENT.TEMPLATES'" [url]="'/templates'" [id]="breadcrumbsId"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>

<div class="row">
    <div class="col-12 col-xxl-4">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            
            <dxi-item dataField="name" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 50, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)) }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.NAME' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>
            
        </dx-form>
    </div>
    <div class="col-12 col-xxl-8">
        <dx-data-grid id="gridMain" class="smaller-header" [dataSource]="formData?.templateAttributes" [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true" (onRowInserted)="rowChanges()" (onRowUpdated)="rowChanges()" (onRowRemoved)="rowChanges()" (onCellHoverChanged)="onCellHoverChanged($event)" (onEditingStart)="rowChanges()" (onInitNewRow)="rowChanges()">
            <dxo-editing mode="form" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true"></dxo-editing>
            
            <dxi-column dataField="name" dataType="string" sortOrder="asc" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.NAME' | translate"></dxi-column>

            <dxi-column dataField="dataType" [width]="200" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'TEMPLATES.DATA_TYPE' | translate">
                <dxo-lookup [dataSource]="templateAttributeDataTypes" [valueExpr]="'value'" [displayExpr]="'label'"></dxo-lookup>
            </dxi-column>
            <dxi-column cssClass="searchable-tooltip" dataField="searchable" dataType="boolean" width="80px" [allowFiltering]="true" [allowSorting]="true" [caption]="'PRODUCTS.PRODUCT_ATTRIBUTE_SEARCHABLE' | translate"></dxi-column>

            <!-- <dx-tooltip showEvent="mouseenter" [hideEvent]="{ name: 'mouseout', delay: 2000 }" target=".searchable-tooltip" >
                <div *dxTemplate="let data of 'content'">
                    {{ 'PRODUCTS.PRODUCT_ATTRIBUTE_SEARCHABLE_HINT' | translate }} 
                </div>
            </dx-tooltip> -->
        </dx-data-grid>
    </div>
</div>
